import { render, staticRenderFns } from "./AgregarRol.vue?vue&type=template&id=809a2bd8&"
import script from "./AgregarRol.vue?vue&type=script&lang=js&"
export * from "./AgregarRol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports